import { render, staticRenderFns } from "./GoalInputAdd.vue?vue&type=template&id=51a1c7e5&"
import script from "./GoalInputAdd.vue?vue&type=script&lang=ts&"
export * from "./GoalInputAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports